module.exports = __webpack_public_path__ + "img/icon-01.b652b183.png";